import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Tercera1994 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 1; i <= 30; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,
      table0:[
              {'color':'#ff3355','shortname':'iberia', 'rivalName':'Iberia', 'pj':12, 'pg':1,'pe':2,'pp':9,'gf':13,'gc':28,'dif':-15, 'pts':4},
              {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':12, 'pg':6,'pe':4,'pp':2,'gf':24,'gc':15,'dif':9, 'pts':16},
	      {'color':'#295e1e','shortname':'malleco', 'rivalName':'Malleco', 'pj':12, 'pg':5,'pe':2,'pp':5,'gf':20,'gc':15,'dif':5, 'pts':12},
	      {'color':'#295e1e','shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':12, 'pg':7,'pe':2,'pp':3,'gf':14,'gc':12,'dif':2, 'pts':16},
	      {'color':'#295e1e','shortname':'animas', 'rivalName':'Dep. Las Ánimas', 'pj':12, 'pg':5,'pe':4,'pp':3,'gf':19,'gc':16,'dif':3, 'pts':14},
	      {'color':'#ff3355','shortname':'mulchen', 'rivalName':'Mulchén U.', 'pj':12, 'pg':2,'pe':4,'pp':6,'gf':8,'gc':18,'dif':-10, 'pts':8},
              {'color':'#295e1e','shortname':'linares', 'rivalName':'Dep. Linares', 'pj':12, 'pg':6,'pe':2,'pp':3,'gf':22,'gc':17,'dif':5, 'pts':14}],

	table1:[
              {'color':'#295e1e','shortname':'malleco', 'rivalName':'Malleco', 'pj':18, 'pg':10,'pe':6,'pp':2,'gf':26,'gc':11,'dif':15, 'pts':26},
              {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':18, 'pg':9,'pe':4,'pp':5,'gf':47,'gc':22,'dif':25, 'pts':22},
              {'color':0,'shortname':'rengo', 'rivalName':'Dep. Rengo', 'pj':18, 'pg':7,'pe':4,'pp':7,'gf':25,'gc':27,'dif':-2, 'pts':18},
              {'color':0,'shortname':'curico', 'rivalName':'Curicó U.', 'pj':18, 'pg':12,'pe':1,'pp':5,'gf':24,'gc':15,'dif':9, 'pts':25},
	      {'color':0,'shortname':'magallanes', 'rivalName':'Magallanes', 'pj':18, 'pg':7,'pe':2,'pp':9,'gf':19,'gc':23,'dif':-4, 'pts':16},
	      {'color':0,'shortname':'animas', 'rivalName':'Dep. Las Ánimas', 'pj':18, 'pg':4,'pe':5,'pp':9,'gf':30,'gc':35,'dif':-5, 'pts':13},
	      {'color':0,'shortname':'gv', 'rivalName':'G. Velásquez', 'pj':18, 'pg':13,'pe':6,'pp':9,'gf':17,'gc':34,'dif':-17, 'pts':12},
	      {'color':0,'shortname':'orocoipo', 'rivalName':'C. Orocoipo', 'pj':18, 'pg':1,'pe':4,'pp':13,'gf':10,'gc':41,'dif':-31, 'pts':6},
              {'color':'#295e1e','shortname':'linares', 'rivalName':'Dep. Linares', 'pj':18, 'pg':11,'pe':3,'pp':4,'gf':34,'gc':16,'dif':18, 'pts':25},
              {'color':0,'shortname':'naval', 'rivalName':'Dep. Talcahuano', 'pj':18, 'pg':4,'pe':9,'pp':5,'gf':22,'gc':30,'dif':-8, 'pts':17}],


    };
  }

  componentDidMount() {
	let newtable = this.sortTable(this.state.table1);
                this.setState({table1:newtable});

	let newtable0 = this.sortTable(this.state.table0);
                this.setState({table0:newtable0});
        }



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){

  let subA = this.subText('#295e1e', 'Clasifica a Fase 2 Ascenso');
  let subP = this.subText('#295e1e', 'Clasifica a Liguilla de Ascenso');
  let subD = this.subText('#ff3355', 'Clasifica a Fase 2 Descenso');

console.log(this.state.id_list)

  return(

	<div style={{textAlign: 'center' }}>
      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Fase 1 Grupo Sur </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table0} />}
	<div style={{ height: '10px' }}></div>
	{subA}
	{subD}
	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Fase 2 Grupo Sur</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
         {subP}

	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Tercera 1994</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Tercera 1994</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Tercera 1994" />
     </div>


  )
}

}
export default Tercera1994;
